import React from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../assets/world_ciber.png';
import Footer from '../components/LandingPage/Footer/Footer';
import Navbar from '../components/LandingPage/Navbar/Navbar';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col justify-between bg-gradient-to-b from-black via-[#0A192F] to-[#060D1B] text-white">
      {/* Navbar siempre arriba */}
      <Navbar fixedTop={0}/>

      {/* Contenido central */}
      <div className="flex flex-col items-center justify-center text-center px-4 py-16">
        <img src={logo} alt="Cyber World" className="max-w-xs md:max-w-sm w-full mb-6 mt-14" />

        <h1 className="text-2xl md:text-3xl font-semibold mb-4 max-w-lg">
          {t('errors.pageNotFound')}
        </h1>
      </div>

      <Footer />
    </div>
  );
};

export default NotFound;
